"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _Parent = require("./Parent.style");
var _Text = _interopRequireDefault(require("../../../../../Text"));
const NavItem = _ref => {
  let {
    title,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Parent.ParentLink, {
    type: "button",
    onClick: onClick,
    "data-test-id": "res-primary-menu-".concat(title === null || title === void 0 ? void 0 : title.toLowerCase())
  }, /*#__PURE__*/_react.default.createElement(_Parent.LabelWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "Body",
    variant: "BoldBlack",
    intlText: title
  })), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "chevron-right",
    size: "lg",
    color: _uiKit.theme.colours.PRIMARY_1
  }));
};
var _default = exports.default = NavItem;